export default "/images/vendor/flag-icon-css/flags/1x1/us.svg?c95087e1a852cf730acc3defc2d52724";